/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ObjectLocationEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const ObjectLocationEnum = {
    NUMBER_1: 1 as ObjectLocationEnum,
    NUMBER_2: 2 as ObjectLocationEnum,
    NUMBER_3: 3 as ObjectLocationEnum,
    NUMBER_4: 4 as ObjectLocationEnum,
    NUMBER_5: 5 as ObjectLocationEnum,
    NUMBER_6: 6 as ObjectLocationEnum,
    NUMBER_7: 7 as ObjectLocationEnum,
    NUMBER_8: 8 as ObjectLocationEnum
};

